import { Box, Card, Typography } from "@mui/material";
import { colors, alphaVar } from "../../../../../../../../../../ui/colors";

export const OtherAreasCardSelectable = ({ area, selected, onToggle }) => {
  return (
    <Box sx={{ p: 1 }}>
      <Card
        onClick={onToggle}
        sx={{
          cursor: "pointer",
          backgroundColor: selected ? alphaVar(colors.orange.base, 0.12) : "var(--fx-surface-base, #FFFFFF)",
          borderRadius: 2,
          border: `2px solid ${selected ? colors.orange.base : alphaVar(colors.gray[200], 0.8)}`,
          boxShadow: selected ? `0 4px 8px ${alphaVar(colors.orange.base, 0.25)}` : "0 1px 2px rgba(0,0,0,0.05)",
          transition: "all 0.2s ease",
          overflow: "hidden",
          height: 135,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          p: 1.5,
          "&:hover": {
            transform: "translateY(-2px)",
            borderColor: colors.orange.base,
          },
        }}
      >
        <Box
          component="img"
          src={area.imageUrl}
          alt={area.name}
          sx={{
            width: 70,
            height: 55,
            objectFit: "contain",
            mb: 0.5,
          }}
        />

        <Typography
          variant="subtitle2"
          fontWeight={700}
          sx={{
            color: colors.gray[600],
            fontSize: 11,
            textAlign: "center",
          }}
        >
          {area.name}
        </Typography>
      </Card>
    </Box>
  );
};
